import React, { useState } from "react";
import { T } from "../theme";
import { Badge, Card, fmt, TapeIcon } from "../ui";

export default function PlayerMarketplaceScreen({ activeListings, myListings, onSelect, onSelectMine, onAdd, canPost }) {
  const [tab, setTab] = useState("browse");

  return (
    <div>
      <div style={{ display: "flex", background: T.statBg, borderRadius: 10, padding: 4, marginBottom: 14 }}>
        {[["browse", "Browse"], ["mine", "My Listings"]].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ flex: 1, background: tab === key ? T.accent : "transparent", border: "none", color: tab === key ? "#fff" : T.muted, padding: "8px 0", borderRadius: 7, cursor: "pointer", fontSize: 12, fontWeight: "bold", fontFamily: T.font, letterSpacing: "0.08em" }}>{label}</button>
        ))}
      </div>

      {tab === "browse" && (
        <div>
          {activeListings.length === 0 ? (
            <div style={{ textAlign: "center", padding: 32, fontSize: 13, color: T.muted }}>No players listed yet.</div>
          ) : (
            activeListings.map((l) => (
              <Card key={l.id} onClick={() => onSelect(l)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}>
                {l.photoUrls?.[0] ? (
                  <img src={l.photoUrls[0]} alt="" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8 }} />
                ) : (
                  <TapeIcon size={44} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: "bold", color: T.text }}>{l.brand} {l.model}</div>
                  <div style={{ fontSize: 11, color: T.muted }}>{l.era ? `${l.era} · ` : ""}{l.powerStatus}</div>
                  {l.condition && <Badge condition={l.condition} />}
                </div>
                <div style={{ fontSize: 16, fontWeight: "bold", color: T.value }}>{fmt(l.price)}</div>
              </Card>
            ))
          )}
        </div>
      )}

      {tab === "mine" && (
        <div>
          {canPost && (
            <button onClick={onAdd} style={{ width: "100%", background: T.btnBg, border: "none", color: "#fff", padding: 12, borderRadius: 8, fontSize: 12, fontWeight: "bold", letterSpacing: "0.1em", cursor: "pointer", fontFamily: T.font, marginBottom: 12 }}>
              + List a Player
            </button>
          )}
          {myListings.length === 0 ? (
            <Card style={{ textAlign: "center", padding: 24 }}>
              <div style={{ fontSize: 13, color: T.muted }}>{canPost ? "You haven't listed any players yet." : "Vault Supreme is required to list a player for sale."}</div>
            </Card>
          ) : (
            myListings.map((l) => (
              <Card key={l.id} onClick={() => onSelectMine(l)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer", opacity: l.status === "sold" ? 0.6 : 1 }}>
                {l.photoUrls?.[0] ? (
                  <img src={l.photoUrls[0]} alt="" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8 }} />
                ) : (
                  <TapeIcon size={44} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: "bold", color: T.text }}>{l.brand} {l.model}</div>
                  <span style={{ fontSize: 9, color: l.status === "sold" ? T.muted : T.accent, fontWeight: "bold", letterSpacing: "0.05em", textTransform: "uppercase" }}>{l.status}</span>
                </div>
                <div style={{ fontSize: 16, fontWeight: "bold", color: T.value }}>{fmt(l.price)}</div>
              </Card>
            ))
          )}
        </div>
      )}
    </div>
  );
}
